// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","moveInfo":"App_moveInfo__FvpSW","heading":"App_heading__8MFcy"};